import { agent } from '@shared/services/agent';
import {
  EnrichedMeetingRoomBooking,
  MeetingRoom,
  MeetingRoomBooking,
  MeetingRoomFacilities,
  MeetRoomCapacityBands
} from '@features/meeting-rooms/pages/models/MeetingRooms';
import { DATE_FORMAT } from "@shared/utils/DateUtils";
import { OfficeEntity } from "./AdvanceHotDeskingService";
import moment from "moment";

export async function getMeetingRooms(officeId: number, capacityBand: MeetRoomCapacityBands, facilities: MeetingRoomFacilities[]): Promise<MeetingRoom[]> {
  let qs = `?capacity=${capacityBand}`;
  if (facilities.length > 0) qs += `&facilities=${facilities.join(',')}`
  return await agent.requests.get(`/api/meeting-rooms/office/${officeId}${qs}`);
}

export async function getAllMeetingRooms(): Promise<MeetingRoom[]> {
  return await agent.requests.get(`/api/meeting-rooms`);
}

export async function getMeetingRoomById(meetingRoomId: string): Promise<MeetingRoom> {
  return await agent.requests.get(`/api/meeting-room/${meetingRoomId}`);
}

export async function deleteMeetingRoom(meetingRoomId: string): Promise<void> {
  await agent.requests.del(`/api/meeting-room/${meetingRoomId}`)
}

export async function updateMeetingRoomPosition(meetingRoomId: string, x: number, y: number): Promise<void> {
  await agent.requests.put(`/api/meeting-rooms/position`, {
    roomId: meetingRoomId,
    x: x,
    y: y,
  });
}

export async function updateMeetingRoomSize(meetingRoomId: string, width: number, height: number): Promise<void> {
  await agent.requests.put(`/api/meeting-rooms/size`, {
    roomId: meetingRoomId,
    width: width,
    height: height,
  });
}

export async function createMeetingRoom(office: OfficeEntity, meetingRoomName: string, meetingRoomCapacity: number, facilities: MeetingRoomFacilities[]) {
  return await agent.requests.post(`/api/meeting-room`, {
    name: meetingRoomName,
    capacity: meetingRoomCapacity,
    officeId: office.id,
    facilities: facilities,
  });
}

export async function updateMeetingRoom(meetingRoom: MeetingRoom): Promise<any> {
  return await agent.requests.put(`/api/meeting-room`, meetingRoom);
}

export async function getMyFutureBookings(): Promise<EnrichedMeetingRoomBooking[]> {
  const httpResp = await agent.requests.get(`/api/my-bookings`);
  return httpResp.map((mr: MeetingRoomBooking) => {
      const splitName = mr.bookerName.split(' ');
      const firstName = splitName.shift() || '';
      const lastName = splitName.join(" ");
      return {
        ...mr,
        firstName: firstName,
        lastName: lastName,
        startDateTime: moment.utc(mr.startDateTime).local(),
        endDateTime: moment.utc(mr.endDateTime).local(),
        dateString: moment.utc(mr.startDateTime).local().format(DATE_FORMAT),
      }
    });
}
